import React, { useEffect, useState, useRef, memo, Fragment } from 'react';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import moment from 'moment';
import _ from 'lodash';

import '../../../../BotReport/index.css';

import ContainerReport from '../../../../ContainerReport';
import iconData from '../../../../../../../assets/images/data.svg';
import { getCompanyMessagesByChannelGraphic } from '../../../../../../../store/actions/reports';
import { BotsCreators } from '../../../../../../../store/actions/bots';
import {
  getFilterPeriodType,
  getTotalGraphic,
} from '../../../../BotReport/graphic-report-helper';

const CHART_INITIAL_STATE = {
  chart: {
    type: 'column',
    width: 850,
    height: 250,
    style: {
      fontFamily: 'Fira Sans',
    },
  },

  title: {
    text: '',
  },

  xAxis: {
    categories: [],
  },

  yAxis: {
    allowDecimals: false,
    min: 0,
    title: {
      text: '',
    },
  },

  tooltip: {
    useHTML: true,
    opacity: 1,
    backgroundColor: '#2B323D',
    borderColor: '#2B323D',
    borderRadius: 10,
    formatter() {
      if (this.y <= 0) {
        return false;
      }
      return `<table style="color: white;"><tr><td style="text-align: center;">${this.x}</td></tr><tr><td style="text-align: center; color: white;">${this.y}</td></tr><tr><td style="text-align: center; color: white;">${this.series.name}</td></tr></table>`;
    },
  },

  plotOptions: {
    column: {
      stacking: 'normal',
    },
  },
  credits: {
    enabled: false,
  },
  legend: {
    align: 'left',
    x: 20,
  },
  series: [
    {
      name: 'Webchat',
      data: [],
      stack: 'male',
      color: '#ffaa00',
      minPointLength: 1.51,
    },
    {
      name: 'Whatsapp',
      data: [],
      stack: 'male',
      color: '#13E676',
      minPointLength: 1.51,
    },
    {
      name: 'Messenger',
      data: [],
      stack: 'male',
      color: '#1491FC',
      minPointLength: 1.51,
    },
  ],
  exporting: {
    enabled: false,
  },
};

const OrgBotsTotalMessagesByChannelGraphic = (props) => {
  const {
    match,
    user,
    listBotsRequest,
    bots,
    getCompanyMessagesByChannelGraphic,
    graphic,
    getRefGraphic,
    componentData,
  } = props;
  const { parentFilter, draggableId, onRemoveClick, isEditMode } =
    componentData;

  const { orgId } = match.params;
  const { startDate, endDate } = parentFilter;
  const token = user.dashboard_token;
  const refChartContainer = useRef(null);
  let botsList = [];

  const timezone =
    user && user?.selectedCompany
      ? user?.selectedCompany.timezone.fuso
      : undefined;

  useEffect(() => {
    if (getRefGraphic) {
      getRefGraphic(refChartContainer);
    }
  });

  /** Object for configuration the Highcharts graphic */
  const [chartOptions, setChartOptions] = useState(CHART_INITIAL_STATE);

  /**
   * Update the bots information for chart series
   */
  useEffect(() => {
    bots === null ? listBotsRequest() : createChartSeries();
  }, [bots]);

  /**
   * Called for fetch new data for this component
   */
  useEffect(() => {
    getCompanyMessagesByChannelGraphic(
      orgId,
      token,
      { startDate, endDate },
      timezone
    );
  }, [parentFilter]);

  /**
   * Called for render the component and change values on UI
   */
  useEffect(() => {
    updateChart();
  }, [graphic]);

  /**
   * Update chart when some information change
   */
  const updateChart = () => {
    const difference = moment.duration(
      moment(endDate.toString()).diff(moment(startDate.toString()))
    );
    const period = getFilterPeriodType(difference);
    const series = updateChartSeries(period);

    const chart = {
      ...chartOptions,
      series,
    };

    setChartOptions(chart);
  };

  /**
   * Update the series property from the chart options object
   */
  const updateChartSeries = () => {
    const series = [];

    const treatedValues = graphic.reduce((accumulate, current) => {
      current.bots.forEach((obj) => {
        const index = accumulate.findIndex(
          (element) =>
            element.channel === obj.channel && element.botName === obj.botName
        );

        if (index !== -1) {
          accumulate[index].count += obj.count;
        } else {
          accumulate.push(obj);
        }
      });

      return accumulate;
    }, []);

    _.forEach(chartOptions.series, (element) => {
      const newElement = _.cloneDeep(element);

      newElement.data = chartOptions.xAxis.categories.map((category) => {
        const found = treatedValues.find(
          (element_) =>
            element_.channel === newElement.name.toLowerCase() &&
            element_.botName === category
        );

        if (found) {
          return found.count;
        }
        return 0;
      });
      series.push(newElement);
    });
    return series;
  };

  /**
   * Make the chart series object data property for the bot name passed
   * @param {string} name
   */
  const getMessagesByChannelChartSeriesObjData = (name) => {
    return _.chain(graphic)
      .map((data) => {
        const channel = _.find(
          data.bots,
          (element) => element.channel === name.toLowerCase()
        );
        if (channel) {
          return { _id: data._id, count: channel.count };
        }
      })
      .pickBy(_.identity)
      .value();
  };

  /**
   * Create the chart series array of data fot showing
   */
  const createChartSeries = () => {
    const xCategories = [];

    formatBotList();
    _.forEach(botsList, (bot) => {
      xCategories.push(bot.name);
    });
    setChartOptions({ ...chartOptions, xAxis: { categories: xCategories } });
  };

  /**
   * Format botList array for get only the information this component need
   */
  const formatBotList = () => {
    botsList = [];
    _.forEach(bots, (bot) => {
      botsList.push({ _id: bot._id, name: bot.title });
    });
  };

  /**
   * Render report container content for the current report component
   */
  const renderContainerContent = () => {
    return (
      <HighchartsReact
        ref={refChartContainer}
        highcharts={Highcharts}
        options={chartOptions}
        allowChartUpdate
      />
    );
  };

  return (
    <ContainerReport
      type="graphic"
      icon={iconData}
      title="Quantidade de Mensagens por Canal"
      containerContent={renderContainerContent()}
      draggableId={draggableId}
      onRemoveClick={onRemoveClick}
      isEditMode={isEditMode}
    />
  );
};

const mapStateToProps = (state) => {
  return {
    bots: state.bots.list,
    user: state.users.signedUser,
    graphic: state.reports.orgBotsTotalMessageByChannelGraphic,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getCompanyMessagesByChannelGraphic,
      listBotsRequest: BotsCreators.listBotsRequest,
    },
    dispatch
  );
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(memo(OrgBotsTotalMessagesByChannelGraphic))
);
